export const options = {
  camicia: true,
  giacca: false,
  pantalone: false,
};

export const prices = {
  club: 0,
  clubColletto: 0,
  clubPolsino: 0,
  contrastoColletto: 0,
  contrastoPolsino: 0,
  iniziali: 5,
  mascherina: 6,
  madreperla: 6,
  ricambio: 10
};

export const owner = {
  lang: "it",
  appName: "VIRTUAL TAILOR",
  appUrl: "https://pierlucabellicoso.netlify.app",
  azienda: "PIERLUCA BELLICOSO - CAMICIE SU MISURA",
  attenzione: "Pierluca Bellicoso",
  indirizzo: "Via Giuseppe Scarlattei",
  citta: "L’Aquila",
  provincia: "AQ",
  cap: "67100",
  email: "info@pierlucabellicoso.it",
  telefono: "+39 0862 413558",
  piva: "01587810662",
  registroDi: "L’Aquila",
  foro: "L’Aquila",
  gdpr: {
    titolare: "Pierluca Bellicoso",
    email: "info@pierlucabellicoso.it",
    data: "07 Gennaio 2021",
  },
  social: {
    facebook: "",
    twitter: "",
    whatsapp: "",
  },
};
